import React, {useContext, useEffect, useState} from 'react'
import {StepFooter} from '../components/footer/StepFooter'
import {HorizontalTable} from '../components/table'
import 'flatpickr/dist/flatpickr.css'
import Flatpickr from 'react-flatpickr'
import {Formik, ErrorMessage, Field} from 'formik'
import {confirmStepSchema, IConfirmStep} from '../../helpers/WizardHelpers'
import {useScheduleBatchMutation} from '../../../../../../redux/api/services/batch'
import {ScheduleBatchRequest} from '../../../../../../redux/api/interfaces/batch'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../../redux/store'
import {WizardContext} from '../core/WizardContext'
import {parseDateToISOString, roundedTime} from '../../../../../../helpers/utilities'
import ModalComponent from '../../../../../../libs/_fri/components/CustomModal/CustomModal'
import {KTSVG} from '../../../../../../template/_metronic/helpers'
import {getRTKError} from '../../../../../../libs/_fri/utils/helpers'

type InputProps = React.HTMLProps<HTMLInputElement>

const CustomInput = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return (
    <div className='position-relative d-flex align-items-center'>
      <span className='position-absolute mx-4'>
        <KTSVG path='/media/soyfri-media/calendar-checked.svg' className='svg-icon-2' />
      </span>
      <input
        className='form-control form-control-solid bg-gray-100 ps-12 flatpickr-input active text-gray'
        onClick={props.onClick}
        ref={ref}
        placeholder='Seleccionar fecha y hora'
      />
    </div>
  )
})

export const StepConfirmData = () => {
  const {submitStep, prevStep} = useContext(WizardContext)
  const [scheduleBatch, {isLoading, isSuccess, isError, error}] = useScheduleBatchMutation()
  const currentBatch = useSelector((state: RootState) => state.batchDetailsSlice)
  const infoState = useSelector((state: RootState) => state.info)
  const [dateTime, setDateTime] = useState<Date>(roundedTime(new Date()))
  const [showModal, setShowModal] = useState<Boolean>(false)

  const onHandleSubmit = async (values: IConfirmStep) => {
    if (!values.dateTime) return

    const requestData: ScheduleBatchRequest = {
      info: infoState,
      requestContent: {
        batchId: currentBatch.batchId,
        scheduleTime: parseDateToISOString(values.dateTime),
        notificationEmail: values.notificationEmail,
        clientTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    }
    scheduleBatch(requestData)
  }

  useEffect(() => {
    if (isSuccess) submitStep()
  }, [isSuccess])

  useEffect(() => {
    if (!isError) return

    setShowModal(true)
  }, [isError])

  return (
    <div className='w-100'>
      <Formik
        initialValues={{dateTime, notificationEmail: currentBatch.notificationEmail}}
        validationSchema={confirmStepSchema}
        onSubmit={onHandleSubmit}
        enableReinitialize
      >
        {({setFieldValue, handleSubmit}) => (
          <form>
            <div className='mb-0 fv-row'>
              <HorizontalTable className={'mb-8'} />
              <span className='separator separator-dashed mb-8'></span>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='d-flex flex-column mb-12'>
                    <label className='form-label mb-3 text-gray fs-2'>Fecha a pagar</label>
                    <Flatpickr
                      options={{
                        enableTime: true,
                        dateFormat: 'd, M, Y, H:i',
                        disableMobile: true,
                        minuteIncrement: 30,
                      }}
                      render={({defaultValue, value, ...props}, ref) => {
                        return <CustomInput ref={ref} />
                      }}
                      onChange={([date]) => {
                        setDateTime(roundedTime(date))
                        setFieldValue('dateTime', date)
                      }}
                      value={dateTime}
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='dateTime' />
                    </div>
                  </div>
                </div>
              </div>
              <span className='separator separator-dashed mb-8'></span>
              <div className='row'>
                <div className='col-md-12'>
                  <div className='d-flex flex-column mb-12'>
                    <label className='form-label mb-3 text-gray fs-2'>
                      Correo electrónico para archivo de resultados
                    </label>
                    <Field
                      name='notificationEmail'
                      type='text'
                      placeholder='Ej. correo@email.com'
                      className='form-control form-control-lg form-control-solid text-primary-dark fs-2'
                    />
                    <div className='text-danger mt-2'>
                      <ErrorMessage name='notificationEmail' />
                    </div>
                  </div>
                </div>
              </div>
              <StepFooter
                className={'pt-15'}
                isLoading={isLoading}
                onNext={handleSubmit}
                onPrev={prevStep}
              />
            </div>
          </form>
        )}
      </Formik>
      {/* TODO: Refactorizar este codigo para utilizar CustomMessage */}
      {showModal && (
        <ModalComponent
          size={'md'}
          variant={'danger'}
          handleConfirm={() => setShowModal(false)}
          handleClose={() => setShowModal(false)}
          textCancel={'Cancelar'}
          textConfirm={'Ok'}
          closeButton={false}
          backdrop={'static'}
        >
          <div className='d-flex  flex-column text-center'>
            <div className='fs-2x fw-semibold text-primary-dark'>Error al programar lote</div>
            <div className='fs-2 text-gray px-22'>{getRTKError(error).description || ''}</div>
          </div>
        </ModalComponent>
      )}
    </div>
  )
}
